import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import App from './components/App';
import * as serviceWorker from './serviceWorker';
import reducer from './reducers';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import './index.scss';

const middleware = [thunk];

const store = createStore(reducer, applyMiddleware(...middleware));

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

serviceWorker.register();
